import {
    BaseQueryFn,
    createApi,
    FetchArgs,
    fetchBaseQuery,
    FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { RootState } from "../../app/store/store";

export const dynamicBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const mainApiUrl = process.env.REACT_APP_API_GATEWAY_ENDPOINT;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl: mainApiUrl,
        prepareHeaders: (headers, { getState }) => {
            const { jwtToken } = (getState() as RootState).auth;
            headers.set("authorization", jwtToken);

            return headers;
        },
    });

    return rawBaseQuery(args, api, extraOptions);
};

export const mainApi = createApi({
    reducerPath: "mainApi",
    baseQuery: dynamicBaseQuery,
    tagTypes: ["getAppealDetails"],
    endpoints: () => ({}),
});
